"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const animejs_1 = require("animejs");
(0, animejs_1.createDraggable)('.board.enabled', {
    y: false, container: '.container'
});
function randomX(square) {
    let left = square;
    const XPosition = Math.floor(Math.random() * ((window.innerWidth - 100) - 100) + 100);
    left.style.left = `${XPosition}px`;
    dropObject(left);
}
function dropObject(target) {
    const duration = Math.floor(Math.random() * (3000 - 1000 + 1) + 1000);
    const containerY = ((window.innerHeight * 0.8) - target.clientHeight);
    (0, animejs_1.animate)(target, {
        translateY: [0, containerY],
        duration: duration,
        easing: "easeInQuad",
        onComplete: function () { randomX(target); }
    });
}
const countDown = document.getElementById("countDown");
const scoreText = document.getElementById("score");
const squares = document.querySelectorAll(".square");
const catcher = document.getElementById("catcher");
let rectCatcher;
let timeLeft = 60;
let score = 0;
function startGame() {
    squares.forEach(function (square) {
        randomX(square);
    });
    let timerId = setInterval(function () {
        countDown.textContent = timeLeft.toString();
        timeLeft--;
        if (timeLeft < 0) {
            clearInterval(timerId);
            countDown.textContent = "TIME'S UP!";
        }
    }, 1000);
}
document.addEventListener("mousemove", e => {
    rectCatcher = catcher.getBoundingClientRect(); // untuk ambil posisi realtime catcher
    // console.log("catcher:", rectCatcher.left);
    isCollide(rectCatcher.left, rectCatcher.top, rectCatcher.right, rectCatcher.bottom);
});
const isCollide = (catcherLeft, catcherTop, catcherRight, catcherBottom) => {
    squares.forEach(square => {
        const rectSquare = square.getBoundingClientRect();
        const collide = !(catcherRight < rectSquare.left ||
            catcherLeft > rectSquare.right ||
            catcherBottom < rectSquare.top ||
            catcherTop > rectSquare.bottom);
        if (collide) {
            randomX(square); //square yg ditangkep lgs dirandom lg
            score++;
            scoreText.textContent = score.toString();
        }
    });
};
startGame();
